import React from "react"
import NavBar from "../NavBar/NavBar"
import Footer from "../../components/core/Footer/Footer"

/**
 * Page — base layout wrapper.
 *
 * Props:
 *   children        — page content
 *   backgroundColor — override background color for the content area
 *   fullBleed       — when true the content div has no padding/margin constraint,
 *                     allowing child sections to use .full-bleed or 100vw widths.
 *                     Defaults to true so sections always have room to bleed edge-to-edge.
 */
const Page = ({ children, backgroundColor, fullBleed = true, hideNavBar = false, minimalFooter = false, hideFooter = false }) => {
  return (
    <React.Fragment>
      {!hideNavBar && <NavBar position="relative" />}
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: backgroundColor,
          // No max-width, no padding, no overflow:hidden — intentional.
          // Individual sections own their own layout constraints.
          ...(fullBleed
            ? { width: "100%", overflowX: "hidden" }
            : { maxWidth: 1200, margin: "0 auto", padding: "0 32px" }),
        }}
      >
        {children}
      </div>
      {!hideFooter && <Footer minimal={minimalFooter} />}
    </React.Fragment>
  )
}

export default Page
